import {
    BonusDisplayStatusDTO,
    EgenandelDisplayStatusDTO,
    MaksKjorelengdeDisplayStatusDTO,
    OppsummeringForsikringOpplysningerDTO,
} from '../../types/generated-types';
import {
    Bonus,
    DisplayStatus,
    Egenandel,
    ForsikringOppsummeringInformation,
    MaksKjorelengde,
} from '../../types/internal-types';
import { SkademeldingOppsummeringActionKeys } from './skademeldingOppsummering-reducer';

export interface UpdateSkademeldingOppsumeringBonusInfo {
    type: SkademeldingOppsummeringActionKeys.UpdateBonusOppsummeringInfo;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export interface UpdateSkademeldingOppsumeringEgenandelInfo {
    type: SkademeldingOppsummeringActionKeys.UpdateEgenandelOppsummeringInfo;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export interface UpdateSkademeldingOppsumeringKjorelengdeInfo {
    type: SkademeldingOppsummeringActionKeys.UpdateKjorelengdeOppsummeringInfo;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export interface UpdateSkademeldingOppsumeringSavingStateToOngoing {
    type: SkademeldingOppsummeringActionKeys.UpdateSavingStateToFetching;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export interface UpdateSkademeldingOppsumeringSavingStateToFinished {
    type: SkademeldingOppsummeringActionKeys.UpdateSavingStateToFinished;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export interface UpdateSkademeldingOppsumeringResetSavingState {
    type: SkademeldingOppsummeringActionKeys.ResetSavingState;
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation;
}

export const getDisplayStatusAsBonusStatus = (displayStatus: DisplayStatus): BonusDisplayStatusDTO => {
    if (displayStatus === DisplayStatus.Show) {
        return BonusDisplayStatusDTO.Show;
    }
    return BonusDisplayStatusDTO.Hide;
};

export const getDisplayStatusAsEgenandelStatus = (displayStatus: DisplayStatus): EgenandelDisplayStatusDTO => {
    if (displayStatus === DisplayStatus.Show) {
        return EgenandelDisplayStatusDTO.Show;
    }
    return EgenandelDisplayStatusDTO.Hide;
};

export const getDisplayStatusAsMaksKjorelengdeStatus = (
    displayStatus: DisplayStatus,
): MaksKjorelengdeDisplayStatusDTO => {
    if (displayStatus === DisplayStatus.Show) {
        return MaksKjorelengdeDisplayStatusDTO.Show;
    }
    return MaksKjorelengdeDisplayStatusDTO.Hide;
};

export const getOppsummeringForsikringOpplysningerDTO = (
    forsikringOppsummeringInformation: ForsikringOppsummeringInformation,
): OppsummeringForsikringOpplysningerDTO => {
    if (
        !forsikringOppsummeringInformation.bonus ||
        !forsikringOppsummeringInformation.egenandel ||
        !forsikringOppsummeringInformation.kjorelengde
    )
        return null;

    return {
        bonus: {
            displayStatus: getDisplayStatusAsBonusStatus(forsikringOppsummeringInformation.bonus.displayStatus),
            tittel: forsikringOppsummeringInformation.bonus.tittel,
            innhold: forsikringOppsummeringInformation.bonus.innhold,
        },
        egenandel: {
            displayStatus: getDisplayStatusAsEgenandelStatus(forsikringOppsummeringInformation.egenandel.displayStatus),
            tittel: forsikringOppsummeringInformation.egenandel.tittel,
            innhold: forsikringOppsummeringInformation.egenandel.innhold,
        },
        kjorelengde: {
            displayStatus: getDisplayStatusAsMaksKjorelengdeStatus(
                forsikringOppsummeringInformation.kjorelengde.displayStatus,
            ),
            tittel: forsikringOppsummeringInformation.kjorelengde.tittel,
            innhold: forsikringOppsummeringInformation.kjorelengde.innhold,
        },
    };
};

export const updateSkademeldingForsikringOppsummeringSavingStateToOngoing =
    (): UpdateSkademeldingOppsumeringSavingStateToOngoing => ({
        type: SkademeldingOppsummeringActionKeys.UpdateSavingStateToFetching,
        forsikringOppsummeringInformation: {},
    });

export const updateSkademeldingForsikringOppsummeringSavingStateToFinished =
    (): UpdateSkademeldingOppsumeringSavingStateToFinished => ({
        type: SkademeldingOppsummeringActionKeys.UpdateSavingStateToFinished,
        forsikringOppsummeringInformation: {},
    });

export const updateSkademeldingForsikringOppsummeringResetSavingState =
    (): UpdateSkademeldingOppsumeringResetSavingState => ({
        type: SkademeldingOppsummeringActionKeys.ResetSavingState,
        forsikringOppsummeringInformation: {},
    });

export const updateBonus = (bonus: Bonus): UpdateSkademeldingOppsumeringBonusInfo => ({
    type: SkademeldingOppsummeringActionKeys.UpdateBonusOppsummeringInfo,
    forsikringOppsummeringInformation: { bonus },
});

export const updateEgenandel = (egenandel: Egenandel): UpdateSkademeldingOppsumeringEgenandelInfo => ({
    type: SkademeldingOppsummeringActionKeys.UpdateEgenandelOppsummeringInfo,
    forsikringOppsummeringInformation: { egenandel },
});

export const updateKjorelengde = (kjorelengde: MaksKjorelengde): UpdateSkademeldingOppsumeringKjorelengdeInfo => ({
    type: SkademeldingOppsummeringActionKeys.UpdateKjorelengdeOppsummeringInfo,
    forsikringOppsummeringInformation: { kjorelengde },
});
